import React from 'react';
import { Award, Target, Heart, TrendingUp } from 'lucide-react';
import { aboutUs } from '../mockData';

const AboutUs = () => {
  const values = [
    {
      icon: Award,
      title: 'Excellence',
      description: 'Committed to delivering superior quality in every print'
    },
    {
      icon: Target,
      title: 'Precision',
      description: 'Attention to detail in every aspect of production'
    },
    {
      icon: Heart,
      title: 'Customer Focus',
      description: 'Your satisfaction is our ultimate goal'
    },
    {
      icon: TrendingUp,
      title: 'Innovation',
      description: 'Continuously adopting latest printing technologies'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {aboutUs.title}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 leading-relaxed">
            {aboutUs.description}
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 max-w-4xl mx-auto">
          {aboutUs.highlights.map((item, index) => (
            <div 
              key={index}
              className="bg-slate-50 rounded-xl p-8 text-center border-2 border-slate-100 hover:border-blue-600 transition-all duration-300 hover:shadow-lg group"
            >
              <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2 group-hover:scale-110 transition-transform">
                {item.value}
              </div>
              <div className="text-slate-700 font-medium">{item.label}</div>
            </div>
          ))}
        </div>

        {/* Story Section */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative rounded-2xl overflow-hidden shadow-xl bg-slate-900 flex items-center justify-center p-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/xp6d68hg_image.png"
              alt="Business Growth and Progress"
              className="w-full h-auto object-contain"
              style={{ maxHeight: '500px', imageRendering: 'crisp-edges' }}
            />
          </div>
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-slate-900">Our Journey</h3>
            {aboutUs.story.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-slate-600 leading-relaxed">
                {paragraph}
              </p>
            ))}
            <div className="flex items-center gap-4 pt-4">
              <div className="h-20 w-1 bg-blue-600"></div>
              <div>
                <div className="text-2xl font-bold text-slate-900">Our Mission</div>
                <p className="text-slate-600 mt-2">
                  To empower pharmaceutical companies with precision-printed leaflets that ensure clear healthcare 
                  communication, regulatory compliance, and patient safety through innovation, reliability, and exceptional service.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div className="bg-slate-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-slate-900 text-center mb-12">Our Core Values</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="text-center group">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">{value.title}</h4>
                  <p className="text-slate-600 text-sm">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
